import app from "flarum/forum/app";
import {extend} from "flarum/common/extend";
import IndexPage from "flarum/forum/components/IndexPage";
import Button from "flarum/common/components/Button";
import {isSigned} from "../Utils";
import PostUser from "flarum/forum/components/PostUser";
import LevelBar from "./LevelBar";
import UserCard from "flarum/forum/components/UserCard";
import Tooltip from "flarum/common/components/Tooltip";

function checkIn() {
  app.request({
    method: "POST",
    url: "/api/checkin"
  }).then((r: any) => {
    if (r.code == 0) {
      app.alerts.show({
        type: "success"
      }, app.translator.trans("rhodes-island.forum.ranks.sign_message", { gained_exp: r.gained_exp }));
      if (app.session.user) {
        app.session.user.pushAttributes(r.user);
      }
    } else {
      let msg = app.translator.trans("rhodes-island.forum.ranks.sign_failed");
      switch (r.code) {
        case 1:
          msg = app.translator.trans("rhodes-island.forum.ranks.already_signed")
          break;
      }
      app.alerts.show({
        type: "error"
      }, msg);
    }
  })
}

app.initializers.add("rhd-forum-ranks", (app) => {
  extend(IndexPage.prototype, "sidebarItems", (items) => {
    items.setPriority("nav", -1);
    if (!app.session.user) return;
    items.add("sign", isSigned() ?
        <p className="IndexPage-signed">{app.translator.trans("rhodes-island.forum.ranks.signed", {continuous: (app.session.user?.data.attributes?.signData as any).continuousSignDays})}</p>
      :
        <Button icon="fas fa-calendar-check" className="Button IndexPage-sign-btn" onclick={checkIn}>
          {app.translator.trans("rhodes-island.forum.ranks.sign")}
        </Button>
    );
  });

  extend(PostUser.prototype, "view", function (view) {
    const user = (this.attrs as any).post.user();

    if (!user) return;

    (view.children as any)?.push(LevelBar.component({ user }));
  });

  extend(UserCard.prototype, "infoItems", function (items) {
    const userRank = (this.attrs as any).user.data.attributes.userRank;

    const expTotal = userRank.experience,
        expLevel = userRank.rank,
        nextLevelTotalExp = userRank.nextRankExperience - userRank.rankExperience,
        nextLevelExp = userRank.experience - userRank.rankExperience,
        expPercent = nextLevelExp / nextLevelTotalExp * 100;

    items.add("level",
      <Tooltip text={app.translator.trans('rhodes-island.forum.ranks.experienceText', { expTotal, nextLevelExp: userRank.nextRankExperience - userRank.experience })}>
        <div class="UserCard-level">
          <div class="UserCard-level-bar" style={'width: ' + expPercent + '%;'}></div>
          <span class="UserCard-levelText">{app.translator.trans("rhodes-island.forum.ranks.levelText")}</span>
          &nbsp;
          <span class="UserCard-levelPoints">{expLevel}</span>
        </div>
      </Tooltip>
      , 210);
  });
});
